import * as React from 'react'
import styled from 'styled-components'
import TopOfPageWithLogo from '@/components/molecules/topOfPageWithLogo/topOfPageWithLogo'
import TopNavigationDesktop from '@/components/molecules/navigation/topNavigationDesktop'
import { NextRouter, withRouter } from 'next/router'
import DesktopDisplayOnly from '../../templates/displays/desktopDisplayOnly'
import { INavigationItem } from 'shared-interfaces'
import LeftAlignedLogo from '@/components/atoms/logo/leftAlignedLogo'

type IStyle = {
    hideLogo: boolean
}

const Wrapper = styled.div<IStyle>`
    position: fixed;
    top: 0px;
    left: 0;
    width: 100%;
    z-index: 5;
    transition: all 0.2s;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
`

const SubWrapper = styled.div`
    width: 100%;
    padding-left: 30px;
    padding-right: 30px;
    max-width: 1800px;

    @media (min-width: 2000px) {
        padding-left: 0px;
        padding-right: 0px;
    }
`

const NaviWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`

const SmallPadding = styled.div`
    padding-top: 10px;
`

interface Props {
    router: NextRouter
    navigation_data?: INavigationItem[]
}

type State = {
    prevScrollPosition: number
    isLogoSectionVisible: boolean
}

class PageTopSectionDesktop extends React.Component<Props, State> {
    state = {
        prevScrollPosition: 0,
        isLogoSectionVisible: true,
    }

    constructor(props: any) {
        super(props)
        this.handleScroll = this.handleScroll.bind(this) //bind function once
    }

    handleScroll = () => {
        const { prevScrollPosition } = this.state
        const currentScrollPos = window.pageYOffset

        const checkVisibility = () => {
            if (currentScrollPos < 10) {
                return true
            }
            if (prevScrollPosition > currentScrollPos) {
                return true
            }
            return false
        }

        return this.setState({
            prevScrollPosition: currentScrollPos,
            isLogoSectionVisible: checkVisibility(),
        })
    }

    componentDidMount() {
        this.setState({ ...this.state, prevScrollPosition: window.pageYOffset })

        window.addEventListener('scroll', this.handleScroll, { passive: true })
        return () => {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, false)
    }

    render() {
        const { navigation_data } = this.props
        let { isLogoSectionVisible } = this.state
        return (
            <DesktopDisplayOnly>
                <Wrapper hideLogo={!isLogoSectionVisible}>
                    <SubWrapper>
                        {isLogoSectionVisible && (
                            <>
                                <TopOfPageWithLogo />
                                <SmallPadding />
                            </>
                        )}

                        {navigation_data && (
                            <NaviWrapper
                                style={{
                                    height: !isLogoSectionVisible
                                        ? '70px'
                                        : 'auto',
                                }}
                            >
                                <TopNavigationDesktop
                                    navigation_data={navigation_data}
                                    isScrollUp={isLogoSectionVisible}
                                />
                                {!isLogoSectionVisible && (
                                    <div
                                        style={{
                                            transform: 'scale(0.8)',
                                        }}
                                    >
                                        <LeftAlignedLogo />
                                    </div>
                                )}
                            </NaviWrapper>
                        )}
                    </SubWrapper>
                </Wrapper>
            </DesktopDisplayOnly>
        )
    }
}

export default withRouter(PageTopSectionDesktop)
